export const RESET_UNIVERSITY_FILTER = 'RESET_UNIVERSITY_FILTER';
